/* eslint-disable @nx/enforce-module-boundaries */
import { Component, Input, OnInit, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { PreloadImgComponent } from '@t-llevo/common-ui';
import { TabElementContent } from 'admin-drivers/src/app/common/components/detail-tab-item/models/TabElement';
import { DetailTabItemComponent } from 'admin-drivers/src/app/common/components/detail-tab-item/detail-tab-item.component';
import { DriverService } from 'admin-drivers/src/app/api/services/driver.service';
import { UploadImageService } from 'admin-drivers/src/app/api/services/upload-image.service';
import { Travel } from 'admin-drivers/src/app/common/models/Travel';
import { LicenseCategoryService } from 'admin-drivers/src/app/api/services/license-category.service';

@Component({
  selector: 't-llevo-details-license-section',
  standalone: true,
  imports: [MatTabsModule, PreloadImgComponent, DetailTabItemComponent],
  template: `
    @if(data.driver && data.driver.licenses.length > 1){
      <mat-tab-group>
      @for(license of data.driver.licenses;track license.licenseNumber){
      <mat-tab [label]="license.licenseNumber">
        <div class="row w-100 h-100 p-3">
          <t-llevo-detail-tab-item
            class="col-6"
            contentClasses="h-100 w-100 d-block"
            rowClasses="py-1"
            [data]="getTabItemsByLicenseNumber(license.licenseNumber)"
          ></t-llevo-detail-tab-item>
          <commonui-preload-img
            class="col-6"
            [urlImg]="license.image"
            [containerClass]="'shadow-sm'"
            imgClass="w-100 h-50"
            [containerHeight]="100"
            [containerWidth]="100"
            unit="%"
          ></commonui-preload-img>
        </div>
      </mat-tab>
      }
    </mat-tab-group>
    }
    @else{
      @if(data.driver){
        <div class="row w-100 h-100 p-3">
          <t-llevo-detail-tab-item
            class="col-6"
            contentClasses="h-100 w-100 d-block text-dark"
            rowClasses="py-1"
            [data]="getTabItemsByLicenseNumber(data.driver.licenses[0].licenseNumber)"
          ></t-llevo-detail-tab-item>
          <commonui-preload-img
            class="col-6 h-50"
            [urlImg]="data.driver.licenses[0].image"
            [containerClass]="'shadow-sm'"
            imgClass="w-100 h-100"
            [containerHeight]="100"
            [containerWidth]="100"
            unit="%"
          ></commonui-preload-img>
        </div>
      }
    }
  `,
  providers: [DriverService, UploadImageService],
})
export class DetailsLicenseSectionComponent implements OnInit {
  @Input({ required: true }) data!: Travel;
  protected tabItems: TabElementContent[][] = [];
  private licenseCatSrv = inject(LicenseCategoryService);

  ngOnInit(): void {
    this.licenseCatSrv.getCategories().subscribe((categ) => {
      this.data.driver?.licenses.forEach((license) => {
        this.tabItems.push([
          {
            name: 'Número de licencia',
            value: license.licenseNumber,
          },
          {
            name: 'Fecha de expedición',
            value: new DatePipe('en-US').transform(
              license.expeditionDate,
              'dd/MM/yyyy'
            ) as string,
          },
          {
            name: 'Año de vencimiento',
            value: license.expiredYear.toString(),
          },
          {
            name: 'Categorías',
            value: license.categories
              .map(
                (category) => categ.find((item) => item.id == category)?.name
              )
              .join(', '),
          },
        ]);
      });
    });
  }

  getTabItemsByLicenseNumber(licenseNumber: string) {
    const tabItemsIndex = this.tabItems.findIndex(
      (tabItem) => tabItem[0].value == licenseNumber
    );
    return this.tabItems[tabItemsIndex];
  }
}
